// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__M35A8","productName":"Table_productName__3pzAx"};